export default "__VITE_ASSET__e69f508e__"